<div class="content-align" [dir]="data.dir">
	<label>{{('forms.common.' + data.rejectKey) | translate}}</label>
	<textarea class="form-control" [(ngModel)]="data.reason" [disabled]="data.disabled" rows="4" name="reason"
		[required]="true"></textarea>

	<br />

	<div [style.textAlign]="'end'">
		<button class="dialog-button dialog-cancel" (click)="close()">
			{{'forms.common.back' | translate}}
		</button>

		<button class="dialog-button dialog-save" *ngIf="!data.disabled" (click)="save()"
			[disabled]="!data.reason">
			{{'forms.common.save' | translate}}
		</button>

	</div>
</div>